import { defineComponent as _defineComponent } from 'vue'
import PublicPortfolioModal from '@/components/partials/public-portfolio/PublicPortfolioModal.vue';
import BravadoCallout from '@/components/common/BravadoCallout/BravadoCallout.vue';
import BravadoToggle from '@/components/common/BravadoToggle/BravadoToggle.vue';
import BravadoButtonV3 from '@/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import type { PublicPortfolioConfiguration } from '@/types/graphql';

type PublicPortfolioEducationHistorySectionModalProps = {
  configuration: PublicPortfolioConfiguration;
};
type PublicPortfolioEducationHistorySectionModalEmits = {
  (event: 'upsert', payload: { configurationAttrs: Partial<PublicPortfolioConfiguration> }): void;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'PublicPortfolioEducationHistorySectionModal',
  props: {
    configuration: null
  },
  emits: ["upsert"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'upsert', payload: { configurationAttrs: Partial<PublicPortfolioConfiguration> }): void;
}), expose: any, slots: any, attrs: any }) {




function handleVisibilityChange(value: boolean) {
  emit('upsert', {
    configurationAttrs: {
      sectionEducationHistoriesIsPublic: value,
    },
  });
}

return { __sfc: true,emit, handleVisibilityChange, PublicPortfolioModal, BravadoCallout, BravadoToggle, BravadoButtonV3 }
}

})